// src/components/Teams/TeamForm.js
import React, { useState, useEffect } from 'react';
import { Form, Button, Spinner } from 'react-bootstrap';

const TeamForm = ({ team, onSubmit, loading }) => {
    const [formData, setFormData] = useState({
        name: '',
        description: ''
    });

    useEffect(() => {
        if (team) {
            setFormData({
                name: team.name || '',
                description: team.description || ''
            });
        }
    }, [team]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
                <Form.Label>Název týmu</Form.Label>
                <Form.Control
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Zadejte název týmu"
                    required
                />
            </Form.Group>

            <Form.Group className="mb-4">
                <Form.Label>Popis (volitelně)</Form.Label>
                <Form.Control
                    as="textarea"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    placeholder="Zadejte popis týmu"
                    rows={3}
                />
            </Form.Group>

            <div className="d-grid">
                <Button
                    type="submit"
                    variant="primary"
                    disabled={loading}
                >
                    {loading ? (
                        <>
                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                            Ukládám...
                        </>
                    ) : (
                        <>{team ? 'Aktualizovat tým' : 'Vytvořit tým'}</>
                    )}
                </Button>
            </div>
        </Form>
    );
};

export default TeamForm;